/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 09:28:47
 * @LastEditTime: 2019-08-22 14:17:01
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import route_page_id from "../utils/route_page_id";
import pageName from '../utils/route_page_name'
import store from "../store";
import {parseTime} from "../utils";

const routes = [
    // {
    //   path: '/',
    //   name: '',
    //   redirect:`/index`,
    // },
    // {
    //   path: '/index',
    //   name: 'index',
    //   component: () =>
    //     import('../view/index')
    // },
    // newIndex
    {
        path: '/',
        name: '',
        redirect: `/newIndex`,
    },
    {
        path: '/newIndex',
        name: 'newIndex',
        component: () =>
            import('../view/newIndex')
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import('../view/register')
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     redirect:`/login/language`,
    // },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import('../view/login')
    },
    // {
    //     path: '/download',
    //     name: 'download',
    //     redirect:`/download/language`,
    // },
    {
        path: '/download',
        name: 'download',
        component: () =>
            import('../view/download')
    },
    {
        path: '/newYearGifts',
        name: 'newYearGifts',
        component: () =>
            import('../view/newYearGifts')
    },
    {
        path: '/task',
        name: 'task',
        component: () =>
            import('../view/task') // 任务中心
    },
    {
        path: '/rank',
        name: 'rank',
        component: () =>
            import('../view/rank') // 返佣排行
    },
    {
        path: '/lottery',
        name: 'lottery',
        component: () =>
            import('../view/lottery') // 盲盒活动
    },
    {
        path: "/Halloween",
        name: "Halloween",
        component: () =>
            import("../view/Halloween")//万圣节活动
    },
    {
        path: '/thirdParty',
        name: 'thirdParty',
        component: () => import('../view/thirdParty')
    },
    {
        path: "/countersign",
        name: "countersign",
        component: () =>
            import("../view/Countersign")
    }, {
        path: '/rule',
        name: "rule",
        component: () =>
            import("../view/rules")
    }, {
        path: "/windPople",
        name: "windPople",
        component: () =>
            import("../view/winprize")

    },
    {
        path: "/apiKey",
        name: "apiKey",
        component: () =>
            import("../view/apiKey")

    },
    {
        path: "/FAQ",
        name: "FAQ",
        component: () =>
            import("../view/apiKey/FAQ.vue")

    },
    {
        path: "/createKey",
        name: "createKey",
        component: () =>
            import("../view/apiKey/createKey.vue")

    },
    {
        path: "/apikeyDetail",
        name: "apikeyDetail",
        component: () =>
            import("../view/apiKey/apikeyDetail.vue")

    },

    {
        path: "/apiKeySuccess",
        name: "apiKeySuccess",
        component: () =>
            import("../view/apiKey/apiKeySuccess.vue")

    },
    {
        path: "/college",//学院
        name: "college",
        component: () =>
            import("../view/college/index.vue")
    },
    {
        path: "/news",
        name: "news",
        component: () =>
            import("../view/college/news")
    },
    {
        path: "/study",
        name: "study",
        component: () =>
            import("../view/college/study")
    },
    {
        path: "/dataPage",
        name: "dataPage",
        component: () =>
            import("../view/college/dataPage")
    },
    {
        path: "/college_detail",
        name: "college_detail",
        component: () =>
            import("../view/college/details")
    },
    {
        path: '/worldcup',
        name: 'worldcup',
        component: () =>
            import("../view/worldcup")
    },
    {
        path: '/purchase',
        name: 'purchase',
        component: () => import('../view/purchase')//一元购
    },
    {
        path: '/prizeHistory',
        name: '/prizeHistory',
        component: () => import('../view/purchase/historylist.vue')//一元购历史记录
    },
    {
        path: '/previous',
        name: '/previous',
        component: () => import('../view/purchase/previousRecords.vue')
    },//一元购往期揭晓
    {
        path: '/lamps',
        name: '/lamps',
        component: () => import('../view/purchase/lamps.vue')
    },
    {
        path: '/prizeDetail',
        name: '/prizeDetail',
        component: () => import('../view/purchase/Productdetails.vue')
    },
    {
        path: '/purchaseRule',
        name: '/purchaseRule',
        component: () => import('../view/purchase/rule.vue')
    },
    {
        path: '/worldcuprule',
        name: 'worldcuprule',
        component: () => import("../view/worldcuprule.vue")
    },
    {
        path: '/contractCompetition',
        name: 'contractCompetition',
        component: () => import('@/view/contractCompetition/index.vue')
    },
    {
        path: '/registration',
        name: 'activityIsSignUp',
        component: () => import('@/view/contractCompetition/activityIsSignUp.vue')
    },
    {
        path: "/tradeCompetition",
        name: 'tradeCompetition',
        component: () => import("../view/tradeCompetition"),
    },
    // ChristmasActivities 圣诞节活动
    {
        path: "/ChristmasActivities",
        name: 'ChristmasActivities',
        component: () => import("@/view/ChristmasActivities.vue"),
    },
    {
        path: "/Inscription",
        name: 'Inscription',
        component: () => import("@/view/InscriptionArea/Inscription.vue"),
    },
    {
        path: "/confirmOrder",
        name: 'confirmOrder',
        component: () => import("@/view/InscriptionArea/confirmOrder.vue"),
    },
    {
        path: '/tokenDetails',
        name: 'tokenDetails',
        component: () => import('@/view/InscriptionArea/tokenDetails.vue')
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('../view/activityCenter')
    },
    {
        path: '/errorPage',
        name: 'errorPage',
        component: () => import('../view/404.vue')
    },
    {
        path: '/downloadMore',
        name: 'downloadMore',
        component: () => import("../view/downloadMore.vue")
    },
    {
        path: '/anniversary',
        name: 'anniversary',
        component: () => import("../view/anniversary.vue")
    },
    {
        path: '/anniversaryActivity',
        name: 'anniversaryActivity',
        component: () => import("../view/anniversaryActivity.vue")
    },
    {
        path: '/contractTrade',
        name: 'contractTrade',
        component: () => import("../view/contractTrade.vue")
    },
    {
        path: '/registersSuc',
        name: 'registersSuc',
        component: () => import("../view/registersSuc.vue")
    },
    {
        //合约交易积分
        path: "/contractPoint",
        name: 'contractPoint',
        component: () => import("../view/contractPoint.vue"),
    },
    {
        //合约交易积分-积分明细
        path: "/pointsDetails",
        name: 'pointsDetails',
        component: () => import("../view/pointsDetails.vue"),
    },
    {
        //延期页面
        path: "/extensionPage",
        name: 'extensionPage',
        component: () => import("../view/extensionPage.vue"),
    },
    {
        path: '/listingTokenFlow',
        name: 'listingTokenFlow',
        component: () => import('../view/freeZone/createSymbolFlow')
    },
    {
        //自由区分享页面
        path: "/lineDownload",
        name: 'lineDownload',
        component: () => import("../view/lineDownload.vue"),
    },
    {
        path: '/verification',
        name: 'verification',
        component: () => import('../view/verification.vue')
    }
]
const router = new Router({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0}
    }
})
router.beforeEach((to, from, next) => {
    if (to.name !== from.name && to.query.invitationCode) {
        sessionStorage.setItem('invitationCode', to.query.invitationCode)
    }
    next()
})
router.afterEach((to, from) => {
    let Arr = ['newIndex', 'register', 'login', 'tradeCompetition', 'listingTokenFlow','verification']//埋点的页面
    // let formType = Arr.indexOf(from.name) !=-1//离开的页面是否是埋点页面
    let toType = Arr.indexOf(to.name) != -1//进入的页面是否是埋点页面
    if (to.name !== from.name && toType) {
        if (to.name == 'register') {
            posthog.capture('$pageview', {
                pageId: route_page_id[to.name],
                name: pageName[to.name],
                channel_url: sessionStorage.getItem('channelUrl') || ''
            });
        } else if (to.name == 'login') {
            posthog.capture('$pageview', {
                pageId: route_page_id[to.name],
                name: pageName[to.name],
                channel_url: sessionStorage.getItem('channelUrl') || ''
            });
        } else {
            posthog.capture('$pageview', {
                pageId: route_page_id[to.name],
                name: pageName[to.name]
            });
        }

    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js